export default __webpack_public_path__ + "static/media/map-view.b258ab6a.svg";